// app/javascript/channels/notification_channel.js
import consumer from "./consumer";

// This channel receives broadcasts for the current_user.
const NotificationChannel = {
  subscription: null,

  subscribe(callback) {
    if (this.subscription) return; // Already subscribed

    this.subscription = consumer.subscriptions.create(
      { channel: "NotificationChannel" },
      {
        connected() {
          console.log("✅ Connected to NotificationChannel");
        },

        disconnected() {
          console.warn("❌ Disconnected from NotificationChannel");
        },

        received(data) {
          if (callback && typeof callback === "function") {
            callback(data);
          }
        },
      }
    );
  },
};

export default NotificationChannel;
